<!-- Original Template -->
<ng-container *ngIf="!enableMachCoreProfileSelector">
  <div
    *ngIf="!profileSelectorFacadeService.fromProfileStandAlone()"
    class="profile-selector-smart-backdrop"
    (click)="onClose()"
  ></div>
  <div
    #profileModal
    [ngClass]="{
      advisorBanner: advisorBanner,
      standalone: profileSelectorFacadeService.fromProfileStandAlone()
    }"
    class="profile-selector-smart"
    id="profile-selector-smart"
    tabindex="0"
    (keydown.escape)="onClose()"
  >
    <ng-container *ngIf="profileSelectorFacadeService as profile">
      <idp-profile-selector-ui
        *ngIf="profile.profileDetails$ | async"
        [profileDetails]="
          (profile.profileDetails$ | async) || emptyContentDetails
        "
        [displayTermsOfUse]="(profile.displayTermsUse$ | async) || false"
        [personalStateSelected]="
          (profile.personalSelectedState$ | async) || false
        "
        [businessStateSelected]="
          (profile.businessSelectedState$ | async) || emptyBusinessStateSelected
        "
        [fromStandAlonePage]="
          profileSelectorFacadeService.fromProfileStandAlone()
        "
        [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
        (emitBusinessProfile)="selectAccount($event)"
        (emitPersonalProfile)="selectAccount($event)"
        (closeFlyout)="onClose()"
        (logout)="onClickLogout($event)"
        (profileAnalytics)="handleProfileAnalytics($event)"
      ></idp-profile-selector-ui>
    </ng-container>
  </div>
</ng-container>

<!-- Reusable Templates -->
<ng-template #deltaLogo>
  <svg
    class="mb-auto flex-shrink-0"
    width="80"
    height="64"
    viewBox="0 0 80 64"
    [attr.fill]="isDesktop ? 'none' : 'currentColor'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_18482_46281"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="-8"
      width="80"
      height="72"
    >
      <rect y="-8" width="79.2453" height="72" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_18482_46281)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.2057 -8.01135L62.0235 14.7275L43.997 14.815L57.1839 1.78898L78.2057 -8.01135Z"
        fill="#E01933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.1016 36.1808L22.5412 29.1015L26.9955 21.137L37.305 19.2447L34.1016 36.1808Z"
        fill="#E01933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.0621 14.8803L49.2343 58.1151L78.3127 -7.98438L44.0621 14.8803Z"
        fill="#991933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5555 29.1348L45.017 64.681L37.3545 19.2578L22.5555 29.1348Z"
        fill="#991933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.1606 -8.15473L7.58616 -7.73853L43.909 14.7105L78.1606 -8.15473Z"
        fill="#E01933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.00128355 -6.49024L22.4622 29.0552L37.2613 19.1782L0.00128355 -6.49024Z"
        fill="#E01933"
      />
    </g>
  </svg>
</ng-template>

<ng-template #profileSelectorContent let-profile="profile">
  <idp-profile-selector-ui
    *ngIf="profile.profileDetails$ | async"
    [profileDetails]="(profile.profileDetails$ | async) || emptyContentDetails"
    [displayTermsOfUse]="(profile.displayTermsUse$ | async) || false"
    [personalStateSelected]="(profile.personalSelectedState$ | async) || false"
    [businessStateSelected]="
      (profile.businessSelectedState$ | async) || emptyBusinessStateSelected
    "
    [fromStandAlonePage]="profileSelectorFacadeService.fromProfileStandAlone()"
    [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
    (emitBusinessProfile)="
      selectAccount($event);
      switchingAccount.showSwitching();
      $event.permType !== 'A' &&
        $event.permType !== 'S' &&
        showSwitching.emit(true)
    "
    (emitPersonalProfile)="selectAccount($event)"
    (closeFlyout)="onClose()"
    (logout)="onClickLogout($event)"
    (profileAnalytics)="handleProfileAnalytics($event)"
  ></idp-profile-selector-ui>
</ng-template>

<!-- New MachCore Template Start -->
<ng-container
  *ngIf="
    enableMachCoreProfileSelector &&
    !profileSelectorFacadeService.fromProfileStandAlone()
  "
>
  <div
    #profileModalMachCore
    [ngClass]="{ advisorBanner: advisorBanner }"
    class="profile-selector-machcore"
    id="profile-selector-smart"
    tabindex="0"
    (keydown.escape)="onClose()"
  >
    <ng-container *ngIf="profileSelectorFacadeService as profile">
      <!-- Desktop Dialog -->
      <dialog
        *ngIf="show && isDesktop"
        class="pop-up"
        aria-labelledby="flyout-profile-selector-header"
        aria-describedby="flyout-profile-selector-description"
        aria-modal="true"
        role="dialog"
        #flyoutProfileSelectorDesktop
      >
        <div
          [ngClass]="{
            '!opacity-none': hideModalOnSelect,
            'laptop:!max-h-[calc(100vh-200px)]': isAlertAdvisory,
            'laptop:!max-h-[calc(100vh-100px)]': !isAlertAdvisory
          }"
          class="pop-up-box w-[375px] !overflow-hidden !pt-0 pl-32 pr-16"
          idpFlyoutPosition
        >
          <div
            class="pop-up-box-header flex items-center !justify-end border-none min-w-[327px] !p-0"
          >
            <h1
              *ngIf="profile.profileDetails$ | async as detail"
              id="pop-up-title"
              class="flex self-end text-heading-sm text-heading mt-[40px] mb-0 !text-[1.5rem] !leading-[1.5rem] min-w-0 break-words flex-1"
            >
              {{ detail.pageHeader.headerTitle }}
            </h1>
            <ng-container *ngTemplateOutlet="deltaLogo"></ng-container>
            <button
              class="pop-up-box-header-close-button mb-[30px] flex-shrink-0"
              (click)="onClose()"
              aria-label="Close pop-up"
            >
              <div class="pop-up-box-header-close-button-icon"></div>
            </button>
          </div>
          <div class="pop-up-box-content pt-8 !mt-0">
            <div class="flex flex-col px-8">
              <ng-container
                *ngTemplateOutlet="
                  profileSelectorContent;
                  context: { profile: profile }
                "
              ></ng-container>
            </div>
          </div>
        </div>
        <form method="dialog" class="pop-up-backdrop">
          <button (click)="onClose()" aria-label="Close pop-up">Close</button>
        </form>
      </dialog>

      <!-- Mobile Dialog -->
      <dialog
        *ngIf="show && !isDesktop"
        class="general-modal !p-0"
        aria-labelledby="flyout-profile-selector-header"
        aria-describedby="flyout-profile-selector-description"
        aria-modal="true"
        role="dialog"
        #flyoutProfileSelectorMobile
      >
        <div
          class="general-modal-box !m-0 !w-full !h-[100vh] !max-w-none !max-h-full"
        >
          <div class="general-modal-header flex items-center justify-end">
            <button
              class="general-modal-close-button"
              (click)="onClose()"
              aria-label="Close modal"
            ></button>
          </div>
          <div class="general-modal-content !px-32 !pt-0">
            <div class="flex items-center !justify-end border-none mb-8">
              <h1
                *ngIf="profile.profileDetails$ | async as detail"
                id="pop-up-title"
                class="flex self-end text-heading-sm text-heading mt-[40px] mb-0 !text-[1.5rem] !leading-[1.5rem] min-w-0 break-words flex-1"
              >
                {{ detail.pageHeader.headerTitle }}
              </h1>
              <ng-container *ngTemplateOutlet="deltaLogo"></ng-container>
            </div>
            <ng-container
              *ngTemplateOutlet="
                profileSelectorContent;
                context: { profile: profile }
              "
            ></ng-container>
          </div>
        </div>
        <form method="dialog" class="general-modal-backdrop">
          <button (click)="onClose()" aria-label="Close modal">Close</button>
        </form>
      </dialog>
    </ng-container>
  </div>
</ng-container>

<!-- New MachCore StandAlone Page -->
<ng-container
  *ngIf="
    enableMachCoreProfileSelector &&
    profileSelectorFacadeService.fromProfileStandAlone()
  "
>
  <ng-container *ngIf="profileSelectorFacadeService as profile">
    <div
      #profileModalMachCore
      [ngClass]="{ advisorBanner: advisorBanner }"
      class="profile-selector-machcore mt-[64px]"
      id="profile-selector-smart"
      tabindex="0"
      (keydown.escape)="onClose()"
    >
      <ng-container *ngIf="profileSelectorFacadeService as profile">
        <div
          *ngIf="show"
          aria-labelledby="flyout-profile-selector-header"
          aria-describedby="flyout-profile-selector-description"
          aria-modal="true"
          role="dialog"
          #flyoutProfileSelectorDesktop
        >
          <div
            class="pop-up-box !opacity-[1] w-[375px] !min-h-[500px] !overflow-hidden !pt-0 pl-32 pr-16 relative"
            idpFlyoutPosition
          >
            <div
              *ngIf="(profile.profileDetails$ | async) === null"
              class="page-loader text-inverse absolute inset-0 flex items-center justify-center z-10"
            >
              Loading...
            </div>
            <div
              class="pop-up-box-header flex items-center !justify-end border-none min-w-[327px] !p-0"
            >
              <h1
                *ngIf="profile.profileDetails$ | async as detail"
                id="pop-up-title"
                class="flex self-end text-heading-sm text-heading mt-[40px] mb-0 !text-[1.5rem] !leading-[1.5rem] min-w-0 break-words flex-1"
              >
                {{ detail.pageHeader.headerTitle }}
              </h1>
              <ng-container *ngTemplateOutlet="deltaLogo"></ng-container>
            </div>
            <div class="pop-up-box-content pt-8 !mt-0">
              <div class="flex flex-col px-8">
                <ng-container
                  *ngTemplateOutlet="
                    profileSelectorContent;
                    context: { profile: profile }
                  "
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<!-- New MachCore Template End -->

<form
  #loginPickerRedirectForm
  class="hiddenForm"
  method="POST"
  [action]="refreshURL"
>
  <div *ngFor="let key of queryParamKeys">
    <input
      *ngIf="paramsToIgnore.indexOf(key) === -1"
      type="hidden"
      [name]="key"
      [value]="queryParams[key]"
    />
  </div>
  <button type="submit"></button>
</form>
